// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__CoverageTermsIterableComponent__amountLabel{font-size:1rem;width:15rem}", "",{"version":3,"sources":["webpack://./src/components/cpmi_Policy-Common/components/CoverageTermsIterableComponent/CoverageTermsIterableComponent.module.scss"],"names":[],"mappings":"AAAA,kDACI,cAAA,CACA,WAAA","sourcesContent":[".amountLabel{\n    font-size:1rem;\n    width:15rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"amountLabel": "app__CoverageTermsIterableComponent__amountLabel"
};
export default ___CSS_LOADER_EXPORT___;
